/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightSupportAttention
 */
export interface FlightSupportAttention {
  /**
   * False means no bounded persisted condition currently requires operator or workflow attention.
   * @type {boolean}
   * @memberof FlightSupportAttention
   */
  required: boolean;
  /**
   * Bounded owner for the projected attention; "none" accompanies required=false.
   * @type {string}
   * @memberof FlightSupportAttention
   */
  owner: FlightSupportAttentionOwnerEnum;
  /**
   * Bounded operational domain requiring attention; "none" accompanies required=false.
   * @type {string}
   * @memberof FlightSupportAttention
   */
  category: FlightSupportAttentionCategoryEnum;
  /**
   * Bounded attention severity; "none" accompanies required=false.
   * @type {string}
   * @memberof FlightSupportAttention
   */
  severity: FlightSupportAttentionSeverityEnum;
  /**
   * Bounded explanation for the attention decision; this field is never null.
   * @type {string}
   * @memberof FlightSupportAttention
   */
  reason: FlightSupportAttentionReasonEnum;
}

/**
 * @export
 */
export const FlightSupportAttentionOwnerEnum = {
  None: "none",
  ApiSupport: "api_support",
  Search: "search",
  Customer: "customer",
  Unknown: "unknown",
} as const;
export type FlightSupportAttentionOwnerEnum =
  (typeof FlightSupportAttentionOwnerEnum)[keyof typeof FlightSupportAttentionOwnerEnum];

/**
 * @export
 */
export const FlightSupportAttentionCategoryEnum = {
  None: "none",
  Booking: "booking",
  Payment: "payment",
  Ticketing: "ticketing",
  Cancellation: "cancellation",
  Refund: "refund",
  Recovery: "recovery",
  Unknown: "unknown",
} as const;
export type FlightSupportAttentionCategoryEnum =
  (typeof FlightSupportAttentionCategoryEnum)[keyof typeof FlightSupportAttentionCategoryEnum];

/**
 * @export
 */
export const FlightSupportAttentionSeverityEnum = {
  None: "none",
  Info: "info",
  Warning: "warning",
  Critical: "critical",
  Unknown: "unknown",
} as const;
export type FlightSupportAttentionSeverityEnum =
  (typeof FlightSupportAttentionSeverityEnum)[keyof typeof FlightSupportAttentionSeverityEnum];

/**
 * @export
 */
export const FlightSupportAttentionReasonEnum = {
  NoAttentionRequired: "no_attention_required",
  BookingNeedsAttention: "booking_needs_attention",
  BookingChangeRequiresAssistance: "booking_change_requires_assistance",
  PaymentNeedsAttention: "payment_needs_attention",
  TicketingNeedsAttention: "ticketing_needs_attention",
  CancellationNeedsAttention: "cancellation_needs_attention",
  RefundNeedsAttention: "refund_needs_attention",
  RecoveryPending: "recovery_pending",
  RecoveryExhausted: "recovery_exhausted",
  ProviderOrderUnavailable: "provider_order_unavailable",
  SupplierRuntimeUnavailable: "supplier_runtime_unavailable",
  CancellationQuoteUnsupported: "cancellation_quote_unsupported",
  CancellationQuoteIdentityMismatch: "cancellation_quote_identity_mismatch",
  CancellationTermsRequireReview: "cancellation_terms_require_review",
  CancellationQuoteUnavailable: "cancellation_quote_unavailable",
  CancellationConfirmUnsupported: "cancellation_confirm_unsupported",
  SupplierCancellationRequiresReconciliation:
    "supplier_cancellation_requires_reconciliation",
  SupplierCancellationUnverified: "supplier_cancellation_unverified",
  CancellationQuoteStale: "cancellation_quote_stale",
  OrderNotCancellable: "order_not_cancellable",
  TravelportMixedRecord: "travelport_mixed_record",
  SupplierCancellationRecoveryExhausted:
    "supplier_cancellation_recovery_exhausted",
  CustomerRefundTermsUnavailable: "customer_refund_terms_unavailable",
  TicketRefundPendingReview: "ticket_refund_pending_review",
  CustomerRefundPreparationRequiresAttention:
    "customer_refund_preparation_requires_attention",
  CustomerRefundAwaitingApproval: "customer_refund_awaiting_approval",
  CustomerRefundRecoveryExhausted: "customer_refund_recovery_exhausted",
  TicketSettlementPreparationFailed: "ticket_settlement_preparation_failed",
  ProviderReconciliationContradiction: "provider_reconciliation_contradiction",
  ProviderPaymentDivergence: "provider_payment_divergence",
  CompatibilityUnknown: "compatibility_unknown",
} as const;
export type FlightSupportAttentionReasonEnum =
  (typeof FlightSupportAttentionReasonEnum)[keyof typeof FlightSupportAttentionReasonEnum];

/**
 * Check if a given object implements the FlightSupportAttention interface.
 */
export function instanceOfFlightSupportAttention(
  value: object
): value is FlightSupportAttention {
  if (!("required" in value) || value["required"] === undefined) return false;
  if (!("owner" in value) || value["owner"] === undefined) return false;
  if (!("category" in value) || value["category"] === undefined) return false;
  if (!("severity" in value) || value["severity"] === undefined) return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  return true;
}

export function FlightSupportAttentionFromJSON(
  json: any
): FlightSupportAttention {
  return FlightSupportAttentionFromJSONTyped(json, false);
}

export function FlightSupportAttentionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSupportAttention {
  if (json == null) {
    return json;
  }
  return {
    required: json["required"],
    owner: json["owner"],
    category: json["category"],
    severity: json["severity"],
    reason: json["reason"],
  };
}

export function FlightSupportAttentionToJSON(
  json: any
): FlightSupportAttention {
  return FlightSupportAttentionToJSONTyped(json, false);
}

export function FlightSupportAttentionToJSONTyped(
  value?: FlightSupportAttention | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    required: value["required"],
    owner: value["owner"],
    category: value["category"],
    severity: value["severity"],
    reason: value["reason"],
  };
}
